import React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

interface Props {
  description: string
  children: React.ReactNode
  openValue: boolean
  toggleAction?: (value: boolean) => void
}

const ToagleSection: React.FC<Props> = ({ description, children, openValue, toggleAction }) => {
  const [open, setOpen] = React.useState(openValue)

  return (
    <Box borderRadius={{ all: 'abs006' }}>
      <CollapsableCard
        open={open}
        Card={
          <Box
            flexDirection="row"
            justifyContent="spaceBetween"
            onClick={() => {
              setOpen(!open)
              if (!!toggleAction) toggleAction(open)
            }}
          >
            <Text.Normal color="grey800">{description}</Text.Normal>
            <TogglerCheckbox value={open} onChange={() => setOpen(!open)} />
          </Box>
        }
        Content={children}
      />
    </Box>
  )
}

export default ToagleSection
